import { Reveal, Overline } from "./Reveal";
import { GALLERY } from "../config/site";

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 bg-brand-sand">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Overline>The Gallery</Overline>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl font-bold text-brand-ink tracking-tight leading-tight">
            Step inside
            <span className="italic text-brand-green"> Greens.</span>
          </h2>
        </Reveal>

        <div className="mt-14 columns-2 md:columns-3 gap-4 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <Reveal key={g.label} delay={(i % 3) * 0.07} className="mb-4 break-inside-avoid">
              <figure
                data-testid={`gallery-item-${g.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group relative rounded-3xl overflow-hidden shadow-soft"
              >
                <img
                  src={g.img}
                  alt={g.alt}
                  loading="lazy"
                  className={`w-full ${g.ratio} object-cover img-warm transition-transform duration-700 ease-out group-hover:scale-105`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-deep/80 to-transparent px-5 pb-4 pt-14 opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                  <span className="text-white font-serif text-lg">{g.label}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
